function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// single product image gallery
const thumbnails = document.querySelectorAll(".thumbnail img");
const mainImageContainer = document.querySelector(".wc-single-product-image");

function setImage(thumbnail) {
  const newImage = thumbnail.cloneNode(true);
  mainImageContainer.innerHTML = "";
  mainImageContainer.append(newImage);
}

thumbnails.forEach((thumbnail) => {
  thumbnail.addEventListener("click", () => setImage(thumbnail));
});

// single product thumbnail slider
const thumbnailSliderContainer = document.querySelector(".thumbnail-slider");
const thumbnailSliderUl = document.querySelector(".thumbnail-slider ul");

if (thumbnailSliderContainer) {
  const thumbnailSliderButtonPrev =
    document.querySelector(".slider-arrow.prev");
  const thumbnailSliderButtonNext =
    document.querySelector(".slider-arrow.next");
  const thumbnailSlides = thumbnailSliderUl.querySelectorAll(".thumbnail");
  const thumbnailCount = thumbnailSlides.length;

  if (thumbnailCount < 4) {
    thumbnailSliderButtonPrev.classList.add("hidden");
    thumbnailSliderButtonNext.classList.add("hidden");
  }

  let activeIndex = 0;
  const thumbHeight = 225;

  const thumbnailSliderHeight = document.querySelector(
    ".wc-single-product-image img"
  ).clientHeight;
  thumbnailSliderContainer.style.maxHeight = `${thumbnailSliderHeight}px`;

  function nextThumbnail(dir) {
    if (dir === "prev") {
      activeIndex++;
    } else {
      activeIndex--;
    }

    if (activeIndex >= 1) {
      activeIndex = (thumbnailCount - 3) * -1;
    } else if (activeIndex - 2 <= thumbnailCount * -1) {
      activeIndex = 0;
    }
    thumbnailSliderUl.style.marginTop = activeIndex * thumbHeight + "px";
  }

  thumbnailSliderButtonPrev.addEventListener("click", () =>
    nextThumbnail("prev")
  );
  thumbnailSliderButtonNext.addEventListener("click", () =>
    nextThumbnail("next")
  );
}

// put shop footer into parallax theme footer
document.querySelector(".shop-footer") &&
  jQuery(".shop-footer").prependTo(".fusion-footer-parallax");

// check hidden gift wrap option
const giftWrapHiddenCheckbox = document.querySelector("[name=gift_wrap]");
const giftWrapLabel = document.querySelector(".js-send-as-gift");
const giftWrapPseudoCheckbox = document.querySelector(".js-gift-wrap");

if (giftWrapHiddenCheckbox) {
  if (giftWrapLabel && giftWrapPseudoCheckbox) {
    giftWrapPseudoCheckbox.addEventListener("change", () => {
      document.querySelector("[name=gift_wrap]").checked =
        giftWrapPseudoCheckbox.checked;
    });
  } else {
    document
      .querySelector(".shipping-meta__item.send-as-gift")
      .classList.add("hidden");
  }
}

if (window.location.pathname === "/account/") {
  document
    .querySelector(".woocommerce-MyAccount-content")
    .classList.add("account-dashboard");
}

if (
  window.location.pathname.includes("/account/") &&
  window.location.pathname !== "/account/"
) {
  const org_title = document.querySelector(
    "h2.avada-woocommerce-myaccount-heading"
  );
  const header_title = document.querySelector(".account-header h3:last-child");

  if (org_title) {
    header_title.innerText = org_title.innerText;
    org_title.remove();
  } else {
    header_title.innerText = "Account";
  }
}

if (
  window.location.pathname.includes("edit-address") &&
  document.querySelector("#update_all_subscriptions_addresses")
) {
  const checkbox = document.querySelector(
    "#update_all_subscriptions_addresses"
  );
  checkbox.checked = true;
}

// TOGGLE LOGIN FORM ON CHECKOUT PAGE
const toggleCheckoutLoginForm = document.querySelector(
  "#toggle-checkout-login-form"
);

if (window.location.pathname.includes("checkout") && toggleCheckoutLoginForm) {
  toggleCheckoutLoginForm.addEventListener("click", () => {
    document.querySelector("#checkout-login-form").classList.toggle("hidden");
  });
}

/**
 *
 * Validate some forms
 *
 */
function clearErrors(e) {
  e.target.closest(".js-input-group").classList.remove("has-error");

  const newsletterPopup = document.querySelector(".newsletter-popup");
  newsletterPopup.classList.remove("ajax-error");
}

function validateWriterForm(form) {
  const currentStepRequiredElements = [...form.querySelectorAll(".required")];

  let valid = true;
  const validationStates = new Array();

  for (let element of currentStepRequiredElements) {
    element.addEventListener("keyup", (e) => clearErrors(e));
    element.addEventListener("change", (e) => clearErrors(e));

    if (element.type === "checkbox" && !element.checked) {
      valid = false;
    }

    if (element.value === null || element.value.trim() === "") {
      valid = false;
    }

    if (element.type === "email") {
      valid = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(element.value);
    }

    validationStates.push(valid);

    if (!valid) {
      element.closest(".js-input-group").classList.add("has-error");
    }
  }
  return validationStates.every((valid) => valid);
}

/**
 *
 * Add to newsletter popup function
 *
 */
function submitNewsletterPopupForm(event) {
  event.preventDefault();

  const newsletterPopup = document.querySelector(".newsletter-popup");
  const submitBtn = newsletterPopupForm.querySelector("button");
  submitBtn.disabled = true;
  submitBtn.dataset.text = submitBtn.innerText;
  submitBtn.innerText = "Loading...";
  newsletterPopup.classList.remove("ajax-error", "ajax-success");

  if (!validateWriterForm(newsletterPopupForm)) {
    submitBtn.disabled = false;
    submitBtn.innerText = submitBtn.dataset.text;
    newsletterPopup.classList.add("ajax-error");
    return;
  }

  const inputs = [...newsletterPopupForm.querySelectorAll("input")];
  const formData = {};

  inputs.forEach((input) => (formData[input.name] = input.value));

  jQuery
    .ajax({
      url: my_ajax_object.ajax_url,
      type: "post",
      data: formData,
    })
    .then((res) => {
      console.log(res);
      newsletterPopup.classList.add("ajax-success");
      newsletterPopup.querySelector(".success").classList.remove("d-none");
      newsletterPopup.querySelector(".init").classList.add("d-none");
    })
    .catch((error) => {
      newsletterPopup.classList.add("ajax-error");
      console.error(error);
    });
}
jQuery(document).ready(() => {
  const newsletterPopupContainer = document.querySelector(
    ".newsletter-popup-container"
  );
  const newsletterPopupForm = document.querySelector("#newsletterPopupForm");

  if (!newsletterPopupForm) {
    return;
  }

  if (!getCookie("NL_SHOWN")) {
    newsletterPopupContainer.classList.remove("d-none");
  } else {
    newsletterPopupContainer.remove();
  }

  newsletterPopupForm.addEventListener("submit", submitNewsletterPopupForm);

  const newsletterPopupCloseBtns = document.querySelectorAll(
    ".js-newsletter-popup-close"
  );
  newsletterPopupCloseBtns.forEach((closeBtn) =>
    closeBtn.addEventListener("click", () => {
      let expires = "";
      const date = new Date();
      const midnight = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        23,
        59,
        59
      );
      expires = "; expires=" + midnight.toGMTString();
      document.cookie = "NL_SHOWN=yes;" + expires + "; path=/";

      newsletterPopupContainer.remove();
    })
  );
});

function get_post_ids() {
  const table = document.querySelector("#the-list");
  const tableRows = table.querySelectorAll("tr input");
  const selectedOrders = [...tableRows].filter((cb) => cb.checked);

  return selectedOrders.map((order) => order.value);
}

function doInternetMarkeBulkAction() {
  const doBulkActionButton = document.querySelector("#doaction");
  const bulkActionSelect = document.querySelector("#bulk-action-selector-top");
  const orderDestinationSelect = document.querySelector(
    "#filter-by-shipping-region"
  );

  if (!doBulkActionButton) {
    return;
  }

  console.info("setup eventlistener for internetmarke bulk action");
  doBulkActionButton.addEventListener("click", (e) => {
    if (bulkActionSelect.value === "wcdpi_bulk_create_shipment") {
      e.preventDefault();
      e.stopImmediatePropagation();
      const orders = get_post_ids();
      const region = orderDestinationSelect.value;

      if (!orders) {
        return null;
      }

      jQuery
        .ajax({
          url: my_ajax_object.ajax_url,
          type: "post",
          data: {
            action: "internetmarke",
            orders,
            region,
          },
        })
        .then((res) => {
          console.log(res);
          window.location =
            "admin.php?page=internetmarke_shipments_bulk_create";
        })
        .catch(console.error);
    }
  });
}

function changeOrderStatusBulkAction() {
  const doBulkActionButton = document.querySelector("#doaction");
  const bulkActionSelect = document.querySelector("#bulk-action-selector-top");

  if (!doBulkActionButton) {
    return;
  }

  console.info("setup eventlistener for change status to completed");
  doBulkActionButton.addEventListener("click", (e) => {
    if (bulkActionSelect.value === "mark_completed") {
      e.preventDefault();
      e.stopImmediatePropagation();
      const orders = get_post_ids();

      if (!orders) {
        console.error("No orders found!");
        return null;
      }
      console.log(orders);

      jQuery
        .ajax({
          url: my_ajax_object.ajax_url,
          type: "post",
          data: {
            action: "internetmarke_change_status",
            orders,
          },
        })
        .then((res) => {
          console.log(res);
          window.location.search = `post_type=shop_order&paged=1&bulk_action%3Dmarked_completed%26changed=${res.data.changed}`;
        })
        .catch(console.error);
    }
  });
}

jQuery(document).ready(() => {
  const $ = jQuery;

  if (window.location.pathname === "/wp-admin/edit.php") {
    doInternetMarkeBulkAction();
    changeOrderStatusBulkAction();
  }

  jQuery("#mobile-menu-toggle").on("click", () => {
    jQuery("#mobile-menu").toggleClass("hidden");
    jQuery("body").toggleClass("menu-active");
  });

  const ajaxAddToCartButton = $(".single_add_to_cart_button");

  if (!ajaxAddToCartButton) {
    return;
  }

  ajaxAddToCartButton.on("click", (e) => {
    e.preventDefault();
    $form = ajaxAddToCartButton.closest("form.cart");
    id = ajaxAddToCartButton.val();
    product_qty = $("input[name=quantity]").val() || 1;
    product_id = $("input[name=product_id]").val() || id;
    variation_id = $("input[name=variation_id]").val() || 0;

    const data = {
      action: "woocommerce_ajax_add_to_cart",
      product_id: product_id,
      product_sku: "",
      quantity: product_qty,
      variation_id: variation_id,
    };

    $(document.body).trigger("adding_to_cart", [ajaxAddToCartButton, data]);

    $.ajax({
      type: "post",
      url: wc_add_to_cart_params.ajax_url,
      data: data,
      beforeSend: () =>
        ajaxAddToCartButton
          .removeClass("added")
          .addClass("loading")
          .html(
            '<svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg> Loading'
          ),
      complete: () =>
        ajaxAddToCartButton
          .addClass("added")
          .removeClass("loading")
          .text("Added to cart"),
      success: (response) => {
        console.log({ response });
        if (response.error & response.product_url) {
          window.location = response.product_url;
          return;
        } else {
          $(document.body).trigger("added_to_cart", [
            response.fragments,
            response.cart_hash,
            ajaxAddToCartButton,
          ]);

          console.log($(".cart-count-badge"));

          $(".cart-count-badge").each(function (index) {
            console.log(index + ": " + $(this).text());
          });
          // $(badge).replaceWith(response.fragments["#cart-count"])
          // );

          console.log($(".cart-count-badge"));

          $(".after-added-to-cart-alert")
            .removeClass("hidden")
            .addClass("flex");

          $(".after-added-to-cart-alert button").on("click", () => {
            $(".after-added-to-cart-alert")
              .addClass("hidden")
              .removeClass("flex");
          });
        }
      },
    });
  });

  const firstPaymentDate = $(".first-payment-date");
  if (firstPaymentDate) {
    firstPaymentDate.html(firstPaymentDate.text().replace(":", ":<br/>"));
  }
});
